class ResolveStrategy {
  name;
  constructor({
    name
  }) {
    this.name = name;
  }
}
export default ResolveStrategy;